import vDatatable from "./v-datatable.vue";

export default Vue => {
  Vue.component("v-datatable", vDatatable);
};
